window.Highcharts = require('highcharts');
require('highcharts/modules/full-screen')(Highcharts);
import './stock/stock2.js'
import './stock/report_error.js'
import './stock/email_registration.js'
import "bootstrap-table";
import "./filer/bootstrap-table-mobile.js"
import 'bootstrap-table/dist/bootstrap-table.css';
import "./filer/bootstrap-table-sticky-header.js"
import "./filer/bootstrap-table-sticky-header.css"
import "./filer/bootstrap-table-jumpto.css"
import "./filer/bootstrap-table-jumpto.js"
window.numbro = require('numbro');
